const dashboardItem = {
  orderItem: {
    unitPrice: 'Unit Price',
    quantity: 'Quantity',
    total: 'Total',
  },
  orderItemPrescription: {
    prescription: 'Prescription',
    ePrescription: 'E-Prescription',
    preOrder: 'Prescription pre-order. A reorder is only possible with a new prescription.',
    toPrescriptionUpload: '(E-)Rezept-Upload',
    ePrescriptionDescriptionSingular: 'E-prescription with {count} item',
    ePrescriptionDescriptionPlural: 'E-prescription with {count} items',
  },
  dashboardItem: {
    reorder: 'Reorder',
    subtotal: 'Subtotal',
    delivery: 'Delivery Service',
    coupon: 'Coupon',
    total: 'Total Amount',
    vat: '(incl. VAT)',
    contactPharmacy: 'Please contact your pharmacy to',
    cancelOrder: 'Cancel Order',
    orderReady: 'Order Ready',
    orderCompleted: 'Completed',
    orderInProgress: 'Order In Progress',
    orderCanceled: 'Canceled',
    orderPending: 'Order Pending',
    inTotal: 'Total',
    order: 'Order',
    pharmacy: 'Pharmacy',
    products: 'Products',
    orderStatus: 'Order Status',
    coPayments: 'Your pharmacy will inform you about the amount of co-payments.',
    yourMessage: 'Your Message:',
    allOrders: 'All Orders',
    action: 'Action',
    unavailableProduct: 'The product { pzn } is no longer available',
    prescriptionNote: '* For pre-orders that contain a prescription, the amount of the co-payment and the price of the medicinal product to be paid by the privately insured patient can only be finally determined and communicated by the pharmacist after the pre-order has been completed. Therefore, the amount shown here is a provisional price information in this case.',
  },
}

export default dashboardItem
